import React from 'react';

export default function PaliacateLoader() {
  return (
    <div className="fixed inset-0 bg-white z-[9999] flex flex-col items-center justify-center" data-testid="paliacate-loader">
      <style>{`
        @keyframes paliacate-fade {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }
        @keyframes paliacate-bar {
          0% { width: 0%; }
          50% { width: 70%; }
          100% { width: 100%; }
        }
        .paliacate-letter {
          display: inline-block;
          animation: paliacate-fade 1.8s ease-in-out infinite;
          font-family: 'Bebas Neue', 'Impact', sans-serif;
          font-size: 3rem;
          letter-spacing: 0.25em;
          color: #1a1a1a;
          font-weight: 400;
        }
        .paliacate-bar-track {
          width: 180px;
          height: 3px;
          background: #f0f0f0;
          border-radius: 3px;
          overflow: hidden;
          margin-top: 28px;
        }
        .paliacate-bar-fill {
          height: 100%;
          background: #E86A1F;
          border-radius: 3px;
          animation: paliacate-bar 1.4s ease-in-out infinite;
        }
      `}</style>
      <div>
        {'PALIACATE'.split('').map((letter, i) => (
          <span
            key={i}
            className="paliacate-letter"
            style={{ animationDelay: `${i * 0.12}s` }}
          >
            {letter}
          </span>
        ))}
      </div>
      <div className="paliacate-bar-track">
        <div className="paliacate-bar-fill" />
      </div>
    </div>
  );
}
